import { Subject } from "rxjs";

const SavingSubject = new Subject();

export { SavingSubject };



// WEBPACK FOOTER //
// ./src/shared/SavingSubject.js